interface Props {
    label: string
    onRemove: () => void
}

export const FilterTag = ({ label, onRemove }: Props) => (
    <span className="inline-flex items-center gap-1 px-3 py-1 rounded-full text-sm font-medium bg-green-100 text-green-800">
        {label}
        <button
            type="button"
            onClick={onRemove}
            className="flex items-center justify-center w-4 h-4 ml-0.5 text-green-700 hover:text-green-900"
            aria-label={`Eliminar ${label}`}
        >
            ×
        </button>
    </span>
)
